import type { GenieKnowledgeEntry } from '../../types';

export const mmn: GenieKnowledgeEntry = {
  id: 'multifocal_motor_neuropathy',
  name: 'Neuropatía Motora Multifocal (NMM)',
  category: 'neuropatico',
  conversation: {
    headline:
      'Neuropatía motora desmielinizante multifocal — tratable con IVIg. Diferencial crítico con ELA.',
    edxHighlights: [
      'Bloqueos de conducción motores en segmentos atípicos (fuera de atrapamientos)',
      'SNAPs sensitivos NORMALES (solo afectación motora)',
      'Asimetría entre nervios y regiones',
      'Anti-GM1 en ~50% de casos',
    ],
    pearls: [
      'Bloqueo en segmento atípico + SNAP normal = favorece NMM sobre ELA.',
      'No confundir bloqueo de Martin-Gruber (fisiológico) con bloqueo patológico.',
    ],
    differentials: [
      { name: 'ELA', distinguishingHint: 'denervación difusa sin bloqueos; no responde a IVIg' },
      { name: 'MMN vs CIDP', distinguishingHint: 'NMM es motora pura y multifocal; CIDP es simétrica' },
    ],
    nextSteps: [
      'Solicitar anti-GM1 IgM',
      'Considerar ecografía de nervio periférico',
      'Respuesta a IVIg confirma el diagnóstico',
    ],
  },
  relatedTiebreakers: ['ela_vs_mmn'],
  orientationHints: {
    temporalFit: ['chronic'],
    whenToSuspect: 'Debilidad motora asimétrica multifocal sin síntomas sensitivos',
  },
};
